module.exports = __webpack_public_path__ + "media/images/star-pattern-2-cb698680922079e3ba285843f85547a8.png";